"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fullClipSpaceSize2d = void 0;
const rc_js_util_1 = require("rc-js-util");
/**
 * @public
 */
exports.fullClipSpaceSize2d = rc_js_util_1.Range2d.f32.factory.createOne(0, 2, 0, 2);
//# sourceMappingURL=full-clip-space-size2d.js.map